/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApp } from 'vue';
import App from './App.vue';
import router from '@/router/index';
import { createPinia, PiniaPlugin } from 'pinia';
import { PiniaLogger } from 'pinia-logger';
import piniaPersistedstate from 'pinia-plugin-persistedstate';
import {
  Button,
  Collapse,
  Checkbox,
  Dropdown,
  Form,
  Input,
  InputNumber,
  Menu,
  Modal,
  Tooltip,
  Tree,
  Radio,
  Slider,
  Select,
  Popover,
  Divider,
  TimePicker,
  Table,
  Switch,
  Spin,
  Alert,
  Tabs
} from 'ant-design-vue';

import Vue3ColorPicker from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';

// tailwind1
import '@/styles/tailwind1.css';
// antd全局样式
import '@/styles/antd.less';
// 全局
import '@/styles/global/index.less';

// tailwind2
import '@/styles/tailwind2.css';

import * as buffer from 'buffer';

if (typeof (window as any).global === 'undefined') {
  (window as any).global = window;
}

if (typeof (window as any).Buffer === 'undefined') {
  (window as any).Buffer = buffer.Buffer;
}

// pinia
const pinia = createPinia();
if (import.meta.env.MODE == 'development') {
  pinia.use(
    PiniaLogger({
      expanded: false,
      disabled: true
    }) as PiniaPlugin
  );
}
pinia.use(piniaPersistedstate);

const app = createApp(App).use(pinia).use(router);

// 加载antd
app
  .use(Vue3ColorPicker)
  .use(Button)
  .use(Collapse)
  .use(Checkbox)
  .use(Modal)
  .use(Dropdown)
  .use(Form)
  .use(Input)
  .use(InputNumber)
  .use(Tooltip)
  .use(Select)
  .use(Menu)
  .use(Tree)
  .use(Popover)
  .use(Alert)
  .use(Spin)
  .use(Slider)
  .use(Radio)
  .use(Divider)
  .use(Switch)
  .use(TimePicker)
  .use(Table)
  .use(Tabs);

app.mount('#app');
